import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const GridWrapper = styled.div<{
  repeat?: number;
  styleGrid?: string;
  stack?: boolean;
}>`
  display: grid;
  grid-template-columns: ${({ repeat = 1 }) => `repeat(${repeat}, 1fr)`};
  column-gap: 55px;
  row-gap: 20px;
  place-items: center;
  width: auto;
  padding: 0 20px;

  @media (max-width: 800px) {
    ${({ stack }) =>
      stack
        ? css`
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            row-gap: 20px;
            column-gap: 0;
            padding: 10px;
          `
        : css`
            display: flex;
            overflow-x: auto;
            gap: 12px;
            scroll-snap-type: x mandatory;
            -webkit-overflow-scrolling: touch;
            padding: 10px;

            & > * {
              flex: 0 0 auto;
              scroll-snap-align: start;
            }

            scrollbar-width: none;
            -ms-overflow-style: none;

            &::-webkit-scrollbar {
              display: none;
            }
          `}
  }

  ${(props: any) => props.styleGrid}
`;
export const IndicatorWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 6px;
  margin-top: -10px;
`;

export const Dot = styled.div<{ active: boolean }>`
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background-color: ${({ active }) => (active ? "#333" : "#ccc")};
  transition: background-color 0.3s ease;
`;
